import type { CustomerNotification, NotificationList, NotificationPreferences } from 'types/engagement.types';
import { API_V1 } from './APIs/APIv1';
import { asList, call } from './engagement';

/**
 * Customer "Mitteilungen" (the bell). Always scoped to the signed-in user by the API — no ids in
 * the query. Named Mitteilungen, never "Inbox": Posteingang means LinkedIn messages in PAI.
 */

export const getNotifications = (limit = 20) =>
  call<unknown>(() => API_V1.get('/notifications', { params: { limit } })).then((d): NotificationList => {
    const obj = (d && typeof d === 'object' && !Array.isArray(d) ? d : {}) as { unread?: number };
    const items = asList<CustomerNotification>(d);
    return { items, unread: typeof obj.unread === 'number' ? obj.unread : items.filter((n) => !n.readAt).length };
  });

export const getUnreadNotificationCount = () =>
  call<unknown>(() => API_V1.get('/notifications/unread-count')).then((d) => {
    if (typeof d === 'number') return d;
    const obj = (d ?? {}) as { unread?: number; count?: number };
    return obj.unread ?? obj.count ?? 0;
  });

export const markNotificationRead = (id: string) => call<unknown>(() => API_V1.post(`/notifications/${encodeURIComponent(id)}/read`));

export const markAllNotificationsRead = () => call<unknown>(() => API_V1.post('/notifications/read-all'));

export const clickNotification = (id: string) => call<unknown>(() => API_V1.post(`/notifications/${encodeURIComponent(id)}/click`));

/** The API answers `{ matrix, fixed, consent: { marketingEmail }, updatedAt }`. */
export const toPreferences = (d: NotificationPreferences): NotificationPreferences => ({
  ...d,
  marketingEmailConsent: typeof d?.consent?.marketingEmail === 'boolean' ? d.consent.marketingEmail : d?.marketingEmailConsent,
});

export const getNotificationPreferences = () =>
  call<NotificationPreferences>(() => API_V1.get('/notifications/preferences')).then(toPreferences);

export const updateNotificationPreferences = (matrix: NotificationPreferences['matrix']) =>
  call<NotificationPreferences>(() => API_V1.put('/notifications/preferences', { matrix })).then(toPreferences);
